import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';

const CartSummary = () => {
  const { items, getCartTotal, getCartItemsCount } = useCart();
  
  const subtotal = getCartTotal();
  const shipping = subtotal > 50 ? 0 : 9.99;
  const tax = subtotal * 0.08; // 8% tax
  const total = subtotal + shipping + tax;

  if (items.length === 0) {
    return null;
  }

  return (
    <div className="bg-gray-50 rounded-lg p-4 sm:p-6">
      <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4">Order Summary</h3>
      
      <div className="space-y-2 sm:space-y-3">
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">Items ({getCartItemsCount()})</span>
          <span className="text-gray-900">${subtotal.toFixed(2)}</span>
        </div>
        
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">Shipping</span>
          <span className="text-gray-900">
            {shipping === 0 ? 'FREE' : `$${shipping.toFixed(2)}`}
          </span>
        </div>
        
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">Tax</span>
          <span className="text-gray-900">${tax.toFixed(2)}</span>
        </div>
        
        <div className="border-t pt-2 sm:pt-3">
          <div className="flex justify-between text-base sm:text-lg font-semibold">
            <span className="text-gray-900">Total</span>
            <span className="text-blue-600">${total.toFixed(2)}</span>
          </div>
        </div>
      </div>

      {shipping > 0 && (
        <div className="mt-3 sm:mt-4 p-2 sm:p-3 bg-blue-50 rounded-md">
          <p className="text-xs sm:text-sm text-blue-700">
            Add ${(50 - subtotal).toFixed(2)} more to get FREE shipping!
          </p>
        </div>
      )}

      <Link 
        to="/checkout"
        className="w-full mt-4 sm:mt-6 bg-blue-600 text-white py-3 px-4 rounded-md font-medium hover:bg-blue-700 transition-colors text-center block text-sm sm:text-base touch-optimized"
      >
        Proceed to Checkout
      </Link>

      <div className="mt-3 sm:mt-4 text-center">
        <Link 
          to="/"
          className="text-blue-600 hover:text-blue-800 text-xs sm:text-sm transition-colors touch-optimized"
        >
          Continue Shopping
        </Link>
      </div>

      <div className="mt-3 sm:mt-4 text-xs text-gray-500 space-y-1">
        <p>• Secure checkout with SSL encryption</p>
        <p>• 30-day return policy</p>
        <p>• Free returns on all orders</p>
      </div>
    </div>
  );
};

export default CartSummary;